import styled from "styled-components";
import AtomPaper from "Components/Atoms/Paper";
import { typography } from "globalConstants";

export type PropsType = any;

const Wrap = styled(AtomPaper)`
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 30px 40px;
`;

const Text = styled.div<any>`
   ${typography.other.t4};
`;
const Number = styled.div`
   ${typography.other.t2};
   color: ${typography.other.color.purple[0]};

   &:after {
      content: " 원";
   }
`;

export default function MoleculeFormTotal(props: PropsType) {
   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <Text>총 결제 금액</Text>
         <Number>{props.children}</Number>
      </Wrap>
   );
}
